import { render, staticRenderFns } from "./template.vue?vue&type=template&id=9876faf0&scoped=true&"
import script from "@/Views/Modules/CheckList/SetupView/component.ts?vue&type=script&lang=ts&"
export * from "@/Views/Modules/CheckList/SetupView/component.ts?vue&type=script&lang=ts&"
import style0 from "@/Views/Modules/CheckList/SetupView/style.scss?vue&type=style&index=0&id=9876faf0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9876faf0",
  null
  
)

export default component.exports